<style>
    @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;1,400;1,500&display=swap');

    p,span,li{
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        /*font-size: 16px;*/
    }
    .title-1{
        padding: 5px;
        margin: 50px;
        border: 1px solid black;
        text-align: center;
        text-transform: capitalize;
    }
    .sub-title{
        margin-left: 50px;
    }
    .info-prop{
        margin:15px
    }
    .data{
        text-decoration: underline;
        margin: 5px;
        font-weight: 700;
    }
    .propretaire,.Locataire{
        margin: 15px;
        padding: 20px;
        border: 1px solid black;
    }
    .theme-contrat,.obligation,.article,.signature{
        margin: 15px;
        padding: 15px;
    }
    li{
        margin: 20px;
    }
    .item-article p{
        margin: 20px;
    }
    .article-description-1{
        padding: 10px;
        border: 1px solid black;
    }
    .article-description-1 .label{
        color: rgb(91, 197, 255);
    }
    .article-description-1 .value-label{
        font-weight: bolder;
        color: black;
        margin-left: 5px;
    }
    .signature{
        display: inline-flex;
        flex-wrap: wrap;
        align-items: center;
    }
    .item2,.item3{
        display: block;
        padding: 100px;
        margin: 50px;
        border: 1px solid black;
    }
    .item1,.item4{
        display: block;
        padding: 100px;
        margin: 50px;
    }

    .numerotation{
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        margin-right: 15px;
    }

</style>
<div id="container">
        <div style="display: flex;justify-content: center;align-items: center;">
            <button mat-mini-fab color="warn" (click)="close()">
                <mat-icon>close</mat-icon>
              </button>
        </div>
        <div class="logo"  style="text-align:center">
                <img [src]="icon" alt="" width="100px" style="display: block;margin-left: auto;margin-right: auto;">
        </div>
        <div class="title-1">
            <h2>CONTRAT DE LOCATION DE VEHICULE ENTRE PARTICLULIERS</h2>
        </div>
        <div class="info-prop">
            <div class="sub-title">
                <h2>Entre les soussigné(e)s :</h2>
            </div>
            <div class="propretaire">
                <div class="info-1">
                    <span>Nom</span>
                    <span class="data">{{vehicule.user.user_name}}</span>
                    <span >Prénom</span>
                    <span class="data">{{vehicule.user.user_surname}}</span>,
                </div>
                <div class="info-2">
                    <span>Né(e) le</span>
                    <span class="data">{{vehicule.user.user_datenais}}</span>
                </div>
                <div class="info-3">
                    <span>Adresse</span>
                    <span class="data">{{vehicule.user.user_adress}}</span>
                </div>
                <div class="info-4">
                    <span>Téléphone</span>
                    <span class="data">{{vehicule.user.user_phone}}</span>
                    <span>Mail</span>
                    <span class="data">{{vehicule.user.email}}</span>
                </div>
                <div>
                    <span>Ci-après désigné(e) « <b>Le Propriétaire</b> » d’une part</span>
                </div>
            </div>
            <div class="sub-title">
                <h2>Et</h2>
            </div>
            <div class="Locataire">
                <div>
                    <span>Nom</span>
                    <span class="data">{{renting.locataire.user_name}}</span>
                    <span>Prénom</span>
                    <span class="data">{{renting.locataire.user_surname}}</span>,
                </div>
                <div>
                    <span>Né(e) le</span>
                    <span class="data">{{renting.locataire.user_datenais}}</span>

                </div>
                <div>
                    <span>Adresse</span>
                    <span class="data">{{renting.locataire.user_adress}}</span>
                </div>
                <div>
                    <span>N° permis de conduire :</span>
                    <span class="data">{{renting.locataire.driver_licenses_number}}</span>
                    <span>Obtenu le :</span>
                    <span class="data">{{renting.locataire.driver_licenses_date}}</span>
                </div>
                <div>
                    <span>Téléphone</span>
                    <span class="data">{{renting.locataire.user_phone}}</span>
                    <span>Mail</span>
                    <span class="data">{{renting.locataire.email}}</span>
                </div>
                <div>
                    <span>Ci-après désigné(e) « Le Locataire » d’autre part,</span>
                </div>
            </div>
        </div>
        <div class="theme-contrat">
            <div class="ligne"><span>Ci-après dénommées ensemble « <b>LES PARTIES</b> »</span></div>
            <div class="title"><h2>IL A PREALABLEMENT ETE RAPPELE QUE :</h2></div>
            <div class="theme-contenu">
                <p>Le présent contrat de location est conclu entre le Locataire et le Propriétaire, personnes
                    physiques agissant à titre non professionnel.</p>
                <p>La société <b>Location Auto Senegal</b>, propriétaire du site <a href="www.siloka.fr">www.siloca.fr</a> (Ci-après désignée
                    « <b>Location Auto France et Dom Tom</b> »), se positionne comme intermédiaire dans la relation entre les Parties.
                    Par conséquent, elle ne saurait être tenue responsable du non-respect des conditions du présent
                    contrat par l’une des parties.</p>
                <p>Les Parties déclarent et garantissent être majeures.</p>
            </div>
        </div>
        <div class="obligation">
            <div class="title"><h2>OBLIGATIONS PREALABLES DU PROPRIETAIRE</h2></div>
            <div>
                <ol type="1">
                    <li>Vérifier que le <b>N° de permis</b> de conduire du Locataire correspond bien au N° mentionné
                        ci-dessus et que ledit permis est bien valable au Sénégal.</li>
                    <li>Vérifier que le Locataire est <b>âgé d’au moins 20 ans et a plus de 2 ans</b> de permis de
                        conduire B.</li>
                </ol>
                <p>
                    Si l’une de ces conditions n’est pas remplie, le Propriétaire devra procéder à l’annulation de la
                    réservation.
                    <b>A défaut, ledit Propriétaire reconnait agir à ses risques et périls dans le non-respect des
                    CGU de la plateforme Location Auto Senegal.</b>
                </p>
            </div>
        </div>
        <div class="article">
            <div class="title"><h2>CECI ETANT RAPPELE, IL A ETE CONVENU CE QUI SUIT :</h2></div>
            <div class="item-article">
                <div class="article-sub-title"><h3><u>Article 1. Objet du contrat</u></h3></div>
                <p><span class="numerotation">1.1</span> Le présent contrat a pour objet la location, de courte ou longue durée d’une voiture de
                    tourisme ou d’un utilitaire (ci-après le « VEHICULE ») pour un usage uniquement privé.
                </p>
                <p>
                    <b>Est expressément exclu du présent contrat :</b> le transport de marchandises ou de
                    voyageurs à titre onéreux.
                </p>
                <div class="article-description-1">
                    <p>
                        <span class="numerotation">1.2</span> Description du Véhicule objet de la location :
                        <ul>
                            <li><span class="label">Catégorie :</span><span  class="value-label">{{vehicule.vehicle_categorie}}</span> </li>
                            <li><span  class="label">Marque :</span><span class="value-label">{{vehicule.vehicle_mark}}</span></li>
                            <li><span  class="label">Modèle :</span><span class="value-label">{{vehicule.vehicle_model}}</span></li>
                            <li><span  class="label">Numéro d’immatriculation :</span><span class="value-label">{{vehicule.vehicle_registration}}</span></li>
                            <li><span  class="label">Date de première immatriculation :</span><span class="value-label">{{vehicule.vehicle_date_release}}</span></li>
                        </ul>
                    
                </div>
                <div>
                    <p>Cette location est personnelle, et par conséquent, non transmissible à un tiers.</p>
                    <div class="article-sub-title"><h3><u>Article 2. Durée du contrat et obligations des parties</u></h3></div>
                </div>
                <div class="article-description-1">
                    <p>
                        <span class="numerotation">2.1</span> Il prendra effet le : <span class="label">{{renting.renting_date_departure}} à {{renting.renting_hour_departure}}</span>. Heures à (Lieu) <span  class="label"></span> <br> Et se terminera la : <span  class="label">{{renting.renting_date_return }} à {{renting.renting_hour_return }}</span>. Heures à (Lieu) <span  class="label"></span>
                    </p>
                </div>

                <div>
                    <p>Il produira ses effets jusqu’à la restitution conforme du véhicule par le Locataire au Propriétaire.</p>
                    <p><span class="numerotation">2.2</span> Le propriétaire s’engage à mettre à la disposition du locataire un véhicule âgé d’au plus
                        15 ans au jour de la remise des clés (cette obligation ne concerne pas les utilitaires) et
                        dans un bon état de fonctionnement.</p>
                    <p>
                        <span class="numerotation">2.3</span> Toute réclamation portant sur des dégâts apparents non signalés lors de la remise du Véhicule ne pourra être considérée par le Propriétaire.
                    </p>
                    <p>
                        <span class="numerotation">2.4</span> Lors du retrait du Véhicule, le propriétaire remet au Locataire les clés du dit véhicule, la photocopie de la carte grise, l’attestation d’assurance en cours de validité, l’attestationde visite technique en cours de validité.
                    </p>
                    <p>
                        <span class="numerotation">2.5</span> La date de retrait du véhicule sera considérée comme celle de la prise en charge du dit véhicule par le Locataire en ce qui concerne sa responsabilité.
                    </p>
                    <p>
                        <span class="numerotation">2.6</span> Aucun retard lors de la restitution du véhicule ne sera toléré, sauf cas de force majeure. Tout prolongement de la durée de location donnera lieu à l’établissement d’un nouveau contrat entre le Locataire et le Propriétaire et devra se faire par l’intermédiaire du site <a href="www.galsenauto.com">www.galsenauto.com</a> et donnera lieu à un nouveau paiement en ligne à ce titre.
                    </p>
                    <p>
                        <span class="numerotation">2.7</span> En toute hypothèse, la durée de la location ne saurait excéder quatre-vingt-dix (90)jours.
                    </p>
                    <p>
                        <span class="numerotation">2.8</span> Le véhicule devra être restituée au Propriétaire dans le même état de propreté qu’au jour de la prise en charge.
                    </p>
                    <p>
                        <span class="numerotation">2.9</span> Lors de la restitution, si une détérioration ou perte du véhicule et/ou de l’un de ses éléments est constatée, le Locataire s’oblige à en payer la réparation ou le remplacement
                        à l’identique. Si le coût des réparations est supérieur à 50.000 Fcfa, l’assurance Galsen
                        Auto prendra en charge l’excédent dans la limite de 15.000.000 Fcfa.
                    </p>
                    <p>
                        <span class="numerotation">2.10</span> Jusqu’à la restitution des clés et papiers du véhicule au Propriétaire, le Locataire
                        demeure le gardien du véhicule et sera donc reconnu responsable des infractions,
                        notamment au Code de la route, et des dommages causés au véhicule et/ou à lui-même
                        ou des tiers.
                    </p>
                    <p>
                        <span class="numerotation">2.11</span> Aucune restitution anticipée du véhicule ne pourra avoir lieu, sauf accord
                        préalable expresse du Propriétaire. Dans une telle hypothèse, le montant total de la
                        location sera dû et conservé dans sa totalité et le Locataire ne pourra demander le
                        remboursement d’une partie du prix de la location.
                    </p>
                    <p>
                        <span class="numerotation">2.12</span> Les Parties dresseront, lors de la remise et lors de la restitution du véhicule, des
                        procès-verbaux contradictoires afin de constater le bon état de marche, l’apparence et
                        la propreté du véhicule.
                    </p>
                    <p>
                        <span class="numerotation">2.13</span> Le Propriétaire est susceptible de géolocaliser son véhicule.
                    </p>
                    <p>
                        <span class="numerotation">2.14</span> Sauf accord préalable avec le propriétaire, il est strictement interdit de quitter
                        le territoire sénégalais avec un véhicule loué sur la plateforme Location Auto Senegal.
                    </p>
                    <p>
                        <span class="numerotation">2.15</span> Le propriétaire autorise le locataire à se déplacer sur l’ensemble du territoire
                        sénégalais
                    </p>
                </div>
            </div>
        </div>
</div>
